import { state } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { LogoutService } from 'src/app/services/logout.service';

@Component({
  selector: 'app-hero-area',
  templateUrl: './hero-area.component.html',
  styleUrls: ['./hero-area.component.css']
})
export class HeroAreaComponent implements OnInit {

  constructor(private apiService : ApiService, private route: ActivatedRoute,
    private router: Router, private appComponent : AppComponent, private logoutService: LogoutService) { }

  invalid_propId = '';
  property_id = '';
  user_dtl: any = [];
  user_details: any = [];
  name = '';
  isMessageShow = false;

  ngOnInit(): void {
    this.user_details = localStorage.getItem("loginDetails");
    this.user_dtl = JSON.parse(this.user_details).user[0];
    this.name= this.user_dtl.name;
  }

  getBillData () {
      this.apiService.get(`get_property?property_id=${this.property_id}`).subscribe(
        (res:any) =>{
          if(res && res.data){
            this.router.navigate([`/property-detail?property_id=${this.property_id}`]);
            this.router.navigate(
              ['/property-detail'],
              { queryParams: { property_id: this.property_id } }
            );
          }
      }, 
      (error) =>{
      this.invalid_propId = error.error.error[0].message;
      })
    }

    registerProperty(){
      if(this.user_details == null){
        this.router.navigate(['/login']);
      }else{
        this.router.navigate(['/register-property']);
      }

    }

    logout(){
      this.logoutService.logout();
      this.user_details = null;
      this.name= '';
      this.isMessageShow = true;
      // setTimeout(()=>{ this.router.navigate(['/']); }, 3000);
      
    }

  
}
